import React from 'react';
import PropTypes from 'prop-types';
import Button from '../Button';
import styles from '../../styles/test/TestStyles.module.css';

/**
 * EmptyReview component for displaying when there are no questions to review
 */
const EmptyReview = ({ onBackToHome }) => {
  return (
    <div className={styles.emptyState}>
      <p>¡No tienes preguntas para repasar!</p>
      <p>Las preguntas que falles en los tests aparecerán aquí.</p>
      <Button
        variant="primary"
        onClick={onBackToHome}
      >
        Volver al inicio
      </Button>
    </div>
  );
};

EmptyReview.propTypes = {
  onBackToHome: PropTypes.func.isRequired
};

export default EmptyReview;